import { render, staticRenderFns } from "./Editd.vue?vue&type=template&id=138c03c6&"
import script from "./Editd.vue?vue&type=script&lang=js&"
export * from "./Editd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports